export default __webpack_public_path__ + "static/media/orden.1e090d4f.svg";